import { render, staticRenderFns } from "./OrganisationManagement.vue?vue&type=template&id=d8ade70c&scoped=true"
import script from "./OrganisationManagement.vue?vue&type=script&lang=js"
export * from "./OrganisationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ade70c",
  null
  
)

export default component.exports